/* eslint-disable */

import { COUNTRY_LIST, ACCOUNT_DETAILS, SELECTED_COUNTRY, CAPTCHA_KEY, CAPTCHA_TOKEN, LOGIN, LOGOUT, RESERVE_CTA_FLOW } from './types';
/*eslint-enable*/
export default (state: any, action: any) => {
    switch (action.type) {
        case COUNTRY_LIST:
            return {
                ...state,
                countryList: action.payload.res,
            };
        case CAPTCHA_TOKEN:
            return {
                ...state,
                captchaToken: action.payload.res,
            };
        case ACCOUNT_DETAILS:
            return {
                ...state,
                accountDetails: action.payload.res
            };
        case SELECTED_COUNTRY:
            return {
                ...state,
                selectedCountry: action.payload.res,
            };
        case CAPTCHA_KEY:
            return {
                ...state,
                recaptchaSiteKey: action.payload.res,
            };
        case LOGIN:
            return {
                ...state,
                isLoggedIn: true
            };
        case LOGOUT: 
            return {
                ...state,
                isLoggedIn: false
            }
        case RESERVE_CTA_FLOW: {
            return {
                ...state,
                isReserveCtaClicked: !state.isReserveCtaClicked
            }
        }
        default:
            return state;
    }
};